// Coffee industry tokens. Kaffa-style cafe palette: deep forest/emerald
// green primary against warm cream surfaces, mustard-gold warning accent,
// pill-shaped buttons and an elegant serif display face.
import { baseTokens } from '../_base/tokens.js';

export const coffeeTokens = {
  ...baseTokens,
  token: {
    ...baseTokens.token,
    colorPrimary: '#1E5B41',
    colorInfo: '#1E5B41',
    colorLink: '#1E5B41',
    colorPrimaryHover: '#164630',
    colorLinkHover: '#164630',
    colorPrimaryActive: '#0F3322',
    colorWarning: '#D9A441',
    colorText: '#ffffff',
    colorTextBase: '#ffffff',
    colorTextHeading: '#1a130d',
    colorTextSecondary: 'rgba(36, 26, 18, 0.68)',
    colorTextTertiary: 'rgba(36, 26, 18, 0.48)',
    colorBgBase: '#FBF4E7',
    colorBgLayout: '#FBF4E7',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorFillAlter: '#F5EAD6',
    colorBorder: '#e8dcc4',
    colorBorderSecondary: '#f0e5cf',
    borderRadius: 14,
    borderRadiusLG: 14,
    borderRadiusSM: 10,
    fontFamily: "'Manrope', system-ui, sans-serif",
  },
  components: {
    ...baseTokens.components,
    Button: { borderRadius: 999 },
    Card: {
      borderRadiusLG: 16,
      colorBorderSecondary: '#f0e5cf',
      boxShadowTertiary: '0 0.5rem 1.5rem rgba(30, 91, 65, 0.1)',
    },
    Select: {
      borderRadius: 10,
      optionSelectedBg: '#E3EFE7',
      optionSelectedColor: '#1E5B41',
    },
    Menu: {
      itemBorderRadius: 10,
      itemSelectedBg: '#E3EFE7',
      itemSelectedColor: '#1E5B41',
      itemHoverBg: '#E3EFE7',
    },
    Pagination: {
      itemActiveBg: '#E3EFE7',
      colorPrimary: '#1E5B41',
      colorPrimaryHover: '#164630',
      colorPrimaryActive: '#0F3322',
    },
  },
};
